var MCN = MCN || {};

(function ($, window, document) {

    var $window = $(window),
        $document = $(document),
        eready = "ready",
        eresize = ["resize", "orientationchange"].join(" "),
        echanged = "domchanged";

    var onDomChanged = function () {
        window.picturefill();
    };

    //Fix page height due to Y shifted columns on multiview templates
    var multiviewPageHeight = function () {

        var $multiviewTemplate = $("#multiview-template"),
            $multiviewFirstCol = $("#multiview-first"),
            $multiviewSecondCol = $("#multiview-second"),
            $main = $("main[role=main]");

        // Fix height of main element
        var setHeight = function () {
            if ($multiviewTemplate.length) {
                if ($.support.currentGrid().index > 2) {

                    var firstHeight = $multiviewFirstCol.height(),
                        secondHeight = $multiviewSecondCol.height(),
                        mainHeight = $main.height(),
                        heightDiff = firstHeight - secondHeight,
                        newHeight = mainHeight - heightDiff;

                    $main.css("maxHeight", newHeight);
                    $main.css("overflow", "hidden");
                }
            }
        };

        // Reset the height for smaller screens
        var resetHeight = function () {
            var currentBpIndex = $.support.currentGrid().index;
            if (currentBpIndex <= 2) {
                $main.css("height", "");
                $main.css("overflow", "visible");
            }
        };

        //setHeight();
        $window.on(eresize, $.debounce(resetHeight, 50));
    };

    var navigationBehavioursInit = function () {

        var $navCol = $(".nav-col"),
            $nav = $("nav[data-megamenu]"),
            $after = $(".after"),
            $parent = $nav.parents(".col-m-2:first"),
            // This is one of those moments where CSS lets you down and
            // you have to go the JS route to fulfill a design.
            setSize = function () {

                // Set the column width. Position fixed is lame.
                var index = $.support.currentGrid().index;
                if (index > 2) {
                    $navCol.width($parent.width());
                }
                else {
                    $navCol.width("");
                }

                var navHeight = $nav.height(),
                    documentHeight = $document.height();

                // Ensure color fills full column.
                $after.height(documentHeight - navHeight);

                // Always hide the menu
                // $nav.megamenu("hide");
            };

        $window.on(eresize, $.debounce(setSize, 50));

        setSize();

        $nav.on("show.r.megamenu", function () {
            $nav.css("display", "block");
        }).on("hidden.r.megamenu", function () {

            // TODO: Investigate this almighty hack.
            window.setTimeout(function () {
                $nav.css("display", "");
            }, 200);
        });
    };

    var renderAdSpecItem = function (item) {

        return `<div class="col-xxs-5 col-m-2-5">            
                                    <a href="${item.Url}" class="ad-logo">    
                                        <picture>
                                            <source srcset="${item.IconMUrl}, ${item.IconM2xUrl} 2x" media="(min-width: 768px)">        
                                                <img srcset="${item.IconUrl}, ${item.Icon2xUrl} 2x" alt="${item.AltText}">    
                                            </picture>
                                        <p class="ellipses">${item.Name}</p>            
                                    </a>
                                </div>`;
    }

    var filterBehavioursInit = function () {

        $(".filter-tab").on("shown.r.dropdown", function (event) {

            var $target = $(event.relatedTarget);

            if ($target.hasClass("autocomplete")) {
                $target.addClass("open");
            }

            $(this).find(".icon").removeClass("icon-mcn-website-icon-font-arrow-down")
                .addClass("icon-mcn-website-icon-font-arrow-up");

        }).on("hide.r.dropdown", function (event) {

            var $target = $(event.relatedTarget);

            if ($target.hasClass("autocomplete")) {
                $target.removeClass("open");
            }

        }).on("hidden.r.dropdown", function () {

            // Look at these class names!
            $(this).find(".icon").removeClass("icon-mcn-website-icon-font-arrow-up")
                .addClass("icon-mcn-website-icon-font-arrow-down");
        });

        // Ensure lists display in a row.
        $(".filter").each(function () {
            var $parentElem = $(this).children("div:first-child");

            $parentElem.each(function () {
                var width = 0,
                filterWidth = $(this).outerWidth();

                if (width > filterWidth) {
                    $parentElem.width(width);
                }
            });
        });

        // Wire up any changes to the web api.
        var $filterForm = $("#filter-form"),
            $channelContainer = $("#channel-container");

        $filterForm.on("change", "input[type=checkbox]", function () {

            var result = $filterForm.serialize(),
                url = "/Umbraco/Api/ChannelRootApi/GetChannels/?" + result;

            // getJSON doesn't try to encode the data
            $.getJSON(url, function (data) {

                if (data.length > 0) {

                    let html = '';
                    data.forEach(item => {
                        html += ` <div class="col-xxs-5 col-m-2-5">
                                    <div class="media ratio-pane">          
                                        <a href="${item.Url}" class="channel-logo">    
                                            <picture>
                                                <source srcset="${item.IconMUrl}, ${item.IconM2xUrl} 2x" media="(min-width: 768px)">        
                                                    <img srcset="${item.IconUrl}, ${item.Icon2xUrl} 2x" alt="${item.AltText}">    
                                                </picture>
                                            <p class="ellipses">${item.Name}</p>            
                                        </a>
                                    </div>
                                </div>`
                    });

                    $channelContainer.empty().html(html);

                } else {

                    $channelContainer.empty().html("<div class=\"no-results\"><p>No Results found</p></div>");
                }
            });
        });
    };

    var adSpecFilterBehavioursInit = function () {

        var $adspecNameForm = $("#adspec-name-form"),
            $adspecChannelForm = $("#adspec-channel-form"),
            $channelContainer = $("#channel-container");

        if (!$adspecNameForm.length || !$adspecChannelForm.length) {
            return;
        }

        // Set up Awesomplete
        $.getJSON("/Umbraco/Api/AdspecRootApi/GetChannels/", function (data) {

            if (data.length > 0) {
                // ReSharper disable once ConstructorCallNotUsed
                new Awesomplete(document.querySelector("#search-site"), { list: data });
            }
        });

        // Set up Awesomplete
        $.getJSON("/Umbraco/Api/AdspecRootApi/GetAdSpecs/", function (data) {

            if (data.length > 0) {
                // ReSharper disable once ConstructorCallNotUsed
                new Awesomplete(document.querySelector("#search-adspec"), { list: data });
            }
        });

        $adspecNameForm.on("submit", function (event) {
            event.preventDefault();

            var query = $adspecNameForm.serialize(),
                url = "/Umbraco/Api/AdspecRootApi/GetAdSpecsByQuery/?" + query;

            // getJSON doesn't try to encode the data
            $.getJSON(url, function (data) {

                if (data.length > 0) {

                    let html = '';
                    data.forEach(item => {
                        html += renderAdSpecItem(item);
                    });

                    $channelContainer.empty().html(html);

                } else {

                    $channelContainer.empty().html("<div class=\"no-results\"><p>No Results found</p></div>");
                }
            });
        });

        $adspecChannelForm.on("submit", function (event) {
            event.preventDefault();

            var channel = $adspecChannelForm.serialize(),
                url = "/Umbraco/Api/AdspecRootApi/GetAdSpecsByChannel/?" + channel;

            // getJSON doesn't try to encode the data
            $.getJSON(url, function (data) {

                if (data.length > 0) {

                    let html = '';
                    data.forEach(item => {
                        html += renderAdSpecItem(item);
                    });

                    $channelContainer.empty().html(html);

                } else {

                    $channelContainer.empty().html("<div class=\"no-results\"><p>No Results found</p></div>");
                }
            });
        });
    };

    $document.on(eready, function () {

        multiviewPageHeight();
        navigationBehavioursInit();
        filterBehavioursInit();
        adSpecFilterBehavioursInit();

    }).on(echanged, onDomChanged);

    /*
    Module / component call
     */
    $(function () {
        if (typeof newsletterModalCookieSettings !== 'undefined') {
            MCN.newsletterModal({
                cookie: {
                    name: newsletterModalCookieSettings.name,
                    expiration: newsletterModalCookieSettings.expiration
                }
            });
        }
    });

    // Global Header
    new MCN.GlobalHeader({
        parent: '#global-header',
        btnOffCanvas: '.btn-offcanvas'
    });

    // Newsletter page
    MCN.NewsletterSubmit('#form-newsletter-signup');

   
    new MCN.NewsArticle({
        container: 'article[role=article]'
    });

    new MCN.ScrollIcon({
        container: 'a.scroll-icon',
        target: '.freetext-module'
    });

    MCN.Utility.StateManager.run();


}(jQuery, window, document));